import { BridgeClient } from 'app/service/bridge/BridgeClient';

/** Merchant policy for exposing indexed product variants in public results. */
export function createBridgeVariantPresentationApi() {
  const client = new BridgeClient();

  return {
    async getSettings() {
      return client.sendMessageWithResponse('variant_presentation.settings.get', {});
    },

    async saveSettings(settings) {
      return client.sendMessageWithResponse('variant_presentation.settings.save', settings);
    },
  };
}
